import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BASE_URL from "../constent";

// Fetch all coupons with optional query parameters
export const fetchAllCoupons = createAsyncThunk(
  "coupons/fetchAllCoupons",
  async (params = {}, { rejectWithValue }) => {
    try {
      // console.log(params);
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const queryParams = new URLSearchParams();
      if (params.fields) queryParams.append("fields", params.fields);
      if (params.sort) queryParams.append("sort", params.sort);
      if (params.search) queryParams.append("search", params.search);
      if (params.page) queryParams.append("page", params.page);
      if (params.limit) queryParams.append("limit", params.limit);

      const response = await axios.get(
        `${BASE_URL}/coupon?${queryParams.toString()}`,
        { headers: { token } }
      );
      // console.log(response);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return { data: [], responseDetails: { count: 0, totalPages: 1 } };
      }
      return rejectWithValue(error.response?.data || "Failed to load coupons");
    }
  }
);

// Fetch single coupon by ID
export const fetchCouponById = createAsyncThunk(
  "coupons/fetchCouponById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/coupon/${id}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch coupon");
    }
  }
);

// Add new coupon
export const addCoupon = createAsyncThunk(
  "coupons/addCoupon",
  async (data, { rejectWithValue }) => {
    // console.log(data);
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.post(`${BASE_URL}/coupon`, data, {
        headers: {
          "Content-Type": "application/json",
          token,
        },
      });

      return response.data.data;
    } catch (error) {
      console.error("addCoupon failed:", error.message, error.response?.data);
      return rejectWithValue(error.response?.data || "Failed to add coupon");
    }
  }
);

// Update coupon by ID
export const updateCouponById = createAsyncThunk(
  "coupons/updateCouponById",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.put(`${BASE_URL}/coupon/${id}`, data, {
        headers: {
          "Content-Type": "application/json",
          token,
        },
      });

      return response.data.data || response.data;
    } catch (error) {
      console.error("Update failed:", error.message, error.response?.data);
      return rejectWithValue(error.response?.data || "Failed to update coupon");
    }
  }
);

// Validate coupon by code
export const validateCoupon = createAsyncThunk(
  "coupons/validateCoupon",
  async (code, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");
      const currency = localStorage.getItem("currency");
      if (!currency) throw new Error("No currency found");
      const response = await axios.post(
        `${BASE_URL}/coupon/validate/${code}`,
        {},
        {
          headers: {
            token,
            iso: currency,
          },
        }
      );

      return response.data.data;
    } catch (error) {
      console.error(
        "Validate coupon failed:",
        error.message,
        error.response?.data
      );
      return rejectWithValue(
        error.response?.data || "Failed to validate coupon"
      );
    }
  }
);

// Toggle coupon status
export const toggleCouponStatus = createAsyncThunk(
  "coupons/toggleCouponStatus",
  async (id, { rejectWithValue }) => {
    try {
      // console.log(id);
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");
      // console.log(token);

      const response = await axios.patch(
        `${BASE_URL}/coupon/${id}/toggle-status`,
        null,
        {
          headers: { token },
        }
      );

      return response.data.data || { id };
    } catch (error) {
      console.error(
        "Toggle status failed:",
        error.message,
        error.response?.data
      );
      return rejectWithValue(
        error.response?.data || "Failed to toggle coupon status"
      );
    }
  }
);

// Delate Coupon
export const DelateCoupon = createAsyncThunk(
  "coupons/DelateCoupon",
  async (id, { rejectWithValue }) => {
    try {
      // console.log(id);
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");
      // console.log(token);
      const response = await axios.delete(`${BASE_URL}/coupon/${id}`, {
        headers: {
          token,
        },
      });

      return response.data.data || { id };
    } catch (error) {
      console.error(
        "Toggle status failed:",
        error.message,
        error.response?.data
      );
      return rejectWithValue(
        error.response?.data || "Failed to toggle coupon status"
      );
    }
  }
);

// Apply Coupon InCart
export const applyCouponInCart = createAsyncThunk(
  "coupons/applyCouponInCart",
  async (code, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");
      const currency = localStorage.getItem("currency");
      if (!currency) throw new Error("No currency found");

      const response = await axios.post(
        `${BASE_URL}/coupon/applyInCart/${code}`,
        {},
        {
          headers: {
            token,
            iso: currency,
          },
        }
      );

      return response.data.data;
    } catch (error) {
      console.error(
        "Validate coupon failed:",
        error.message,
        error.response?.data
      );
      return rejectWithValue(
        error.response?.data || "Failed to validate coupon"
      );
    }
  }
);
const couponSlice = createSlice({
  name: "coupons",
  initialState: {
    allCoupons: [],
    selectedCoupon: null,
    validatedCoupon: null,
    loading: false,
    error: null,
    couponCount: null,
    totalPages: null,
  },
  reducers: {
    clearValidatedCoupon: (state) => {
      state.validatedCoupon = null;
    },
    clearSelectedCoupon: (state) => {
      state.selectedCoupon = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch all coupons
      .addCase(fetchAllCoupons.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllCoupons.fulfilled, (state, action) => {
        state.loading = false;
        state.allCoupons = action.payload.data;
        state.couponCount = action.payload.responseDetails.count;
        state.totalPages = action.payload.responseDetails.totalPages;
      })
      .addCase(fetchAllCoupons.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      // Fetch coupon by ID
      .addCase(fetchCouponById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCouponById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCoupon = action.payload;
      })
      .addCase(fetchCouponById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      // Add coupon
      .addCase(addCoupon.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addCoupon.fulfilled, (state, action) => {
        state.loading = false;
        state.allCoupons.push(action.payload);
      })
      .addCase(addCoupon.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      // Update coupon
      .addCase(updateCouponById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCouponById.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.allCoupons.findIndex(
          (coupon) => coupon._id === action.payload._id
        );
        if (index !== -1) {
          state.allCoupons[index] = action.payload;
        }
      })
      .addCase(updateCouponById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      // Validate coupon
      .addCase(validateCoupon.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(validateCoupon.fulfilled, (state, action) => {
        state.loading = false;
        state.validatedCoupon = action.payload;
      })
      .addCase(validateCoupon.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      // apply coupon InCart
      .addCase(applyCouponInCart.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(applyCouponInCart.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCoupon = action.payload;
      })
      .addCase(applyCouponInCart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      // Toggle status
      .addCase(toggleCouponStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(toggleCouponStatus.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.allCoupons.findIndex(
          (coupon) => coupon._id === action.payload.id
        );
        if (index !== -1 && action.payload.status !== undefined) {
          state.allCoupons[index].status = action.payload.status;
        }
      })
      .addCase(toggleCouponStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { clearValidatedCoupon, clearSelectedCoupon } =
  couponSlice.actions;
export default couponSlice.reducer;
